// Imported country values may be empty or malformed; display must never crash.
export function countryDisplayName(value: unknown, locale = "en"): string {
  const code = String(value ?? "").trim().toUpperCase();
  if (!code) return "";
  if (!/^[A-Z]{2}$/.test(code)) return String(value);
  try {
    return new Intl.DisplayNames([locale], { type: "region" }).of(code) ?? code;
  } catch {
    return code;
  }
}
